import classNames from 'classnames';
import { RouterLink, RouterLinkProps } from 'app/src/components/RouterLink';
import React from 'react';
import styles from './HeaderLink.less';

export interface HeaderLinkProps extends RouterLinkProps {
  buttonStyle?: string;
}

export const HeaderLink: React.FunctionComponent<HeaderLinkProps> = ({
  children,
  className,
  buttonStyle,
  ...rest
}) => (
  <RouterLink
    {...rest}
    className={classNames(
      buttonStyle
        ? [styles.headerButton, styles[buttonStyle]]
        : styles.textLink,
      className,
    )}
  >
    {children}
  </RouterLink>
);
